module.exports = __webpack_public_path__ + "img/base_user_img01.b5d37af3.png";